import { Box, Skeleton } from '@mui/material';

export default function TelephonyDetailSkeleton() {
  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center' gap={2}>
        <Box display='flex' gap={1} alignItems='center'>
          <Skeleton variant='text' width={120} height={30} />
          <Skeleton variant='rounded' width={140} height={23} sx={{ borderRadius: '999px' }} />
        </Box>
        <Skeleton variant='rounded' width={160} height={36} sx={{ borderRadius: '18px' }} />
      </Box>

      <Skeleton variant='text' width='70%' height={20} sx={{ mt: 0.5, mb: 2 }} />

      <Skeleton variant='rounded' width='100%' height={44} sx={{ mb: 2, borderRadius: '4px' }} />

      <Box bgcolor='white' p={{ xs: 2, lg: 3 }} borderRadius='4px' border='1px solid #ECECEC'>
        <Skeleton variant='text' width={140} height={24} sx={{ mb: 0.5 }} />
        <Skeleton variant='text' width='85%' height={20} sx={{ mb: 2 }} />
        <Skeleton variant='rounded' width='100%' height={48} sx={{ mb: 1.5, borderRadius: '4px' }} />
        <Skeleton variant='rounded' width='100%' height={48} sx={{ mb: 1.5, borderRadius: '4px' }} />
        <Skeleton variant='rounded' width='100%' height={48} sx={{ mb: 1.5, borderRadius: '4px' }} />
        <Skeleton variant='rounded' width='100%' height={48} sx={{ borderRadius: '4px' }} />
      </Box>

      <Box mt={2} bgcolor='white' p={{ xs: 2, lg: 3 }} borderRadius='4px' border='1px solid #ECECEC'>
        <Skeleton variant='text' width={220} height={24} sx={{ mb: 0.5 }} />
        <Skeleton variant='text' width='90%' height={20} sx={{ mb: 2 }} />
        <Skeleton variant='rounded' width='100%' height={120} sx={{ mb: 2, borderRadius: '4px' }} />
        <Skeleton variant='rounded' width='100%' height={48} sx={{ borderRadius: '4px' }} />
      </Box>
    </>
  );
}
